import { useCallback } from 'react';

import { useLocatorStore } from '../store/useLocatorStore';
const BASE_URL = import.meta.env.VITE_BASE_URL;

type Props = {
  className?: string;
  focusInput: () => void;
};

const options = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0,
};

function onError(err: GeolocationPositionError) {
  // eslint-disable-next-line no-console
  console.warn(`error getting user position:(${err.code}): ${err.message}`);
}

function getPosition(options?: PositionOptions): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) =>
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  );
}

export function GeoLocator({ className = '' }: Props) {
  const searchInput = useLocatorStore((state) => state.searchInput);
  const {
    setSearchInput,
    setCurrentLocation,
    setShouldGeoLocate,
    setRadius,
    setClosestClinic,
    setMapViewBounds,
    setListType,
  } = useLocatorStore((state) => state);

  function clearSearch() {
    setRadius(undefined);
    setClosestClinic(undefined);
    setCurrentLocation(undefined);
    setSearchInput('');
    // @ts-expect-error
    setMapViewBounds(undefined);
    setListType('map');
  }

  const onSuccess = useCallback(async function ({ coords }: GeolocationPosition) {
    clearSearch();
    setCurrentLocation({ lat: coords.latitude, lng: coords.longitude });
    setShouldGeoLocate(true);
  }, []);

  const handleClick = useCallback(function () {
    getPosition(options).then(onSuccess).catch(onError);
    // @ts-expect-error
    if (window.dataLayer) {
      // @ts-expect-error
      window.dataLayer.push({
        'event': 'Use My Location',
      });
    }
  }, []);

  function handleClickClearClick(e: React.MouseEvent<HTMLImageElement>) {
    e.stopPropagation();
    setSearchInput('');
  }

  if (!navigator.geolocation) return null;

  return searchInput.length ? (
    <img
      src={`${BASE_URL}/assets/images/icons/cross.svg`}
      alt="geo locator icon"
      className={`h-[14px] w-[14px] cursor-pointer mt-[-18px]`}
      onClick={handleClickClearClick}
    />
  ) : (
    <img
      src={`${BASE_URL}/assets/images/icons/locate.svg`}
      alt="geo locator icon"
      className={`h-[21px] w-[21px] cursor-pointer ${className}`}
      onClick={handleClick}
    />
  );
}
